export default function ({ route, redirect }) {
    // Проверяем, что путь не заканчивается на /
    const endsWith = (str, search, length = str.length) => str.substring(length - search.length, length) === search;

    if (!endsWith(route.path, "/") && route.path !== "/") {
        // Редиректим на путь со слешем
        return redirect(301, route.path + "/", route.query);
    }
}
